import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { finalizeOnboarding } from '../../api';
import { jwtDecode } from 'jwt-decode';

const LoadingRedirect = ({ leadId }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Initializing your account...');
  
  useEffect(() => {
    const completeOnboarding = async () => {
      try {
        // First update status
        setStatus('Setting up your workspace...');
        
        // Call the API to finalize onboarding
        const response = await finalizeOnboarding(leadId);
        
        if (response.success) {
          const res = response.data;
          console.log("Onboarding Response:", res); // Debugging
          
          // Use a function to set all localStorage items and return a promise
          const setLocalStorageItems = () => {
            return new Promise((resolve) => {
              // Store all required information in local storage
              localStorage.setItem('token', res.access);
              localStorage.setItem('refresh_token', res.refresh);
              localStorage.setItem('role', res.role);
              
              // Decode the JWT token to get permissions and plan
              const decodedToken = jwtDecode(res.access);
              // console.log("Decoded Token:", decodedToken); // Debugging
              
              // Store user data
              localStorage.setItem('user', JSON.stringify(res.user));
              
              // Store permissions from decoded token
              localStorage.setItem('permissions', JSON.stringify(decodedToken.permissions || []));
              
              // Store other required data
              localStorage.setItem('code', decodedToken.code || '');
              localStorage.setItem('tenant', res.tenant || '');
              localStorage.setItem('features', JSON.stringify(res.features || {}));
              localStorage.setItem('apps', JSON.stringify(res.apps || []));
              localStorage.setItem('MAX_USER_COUNT', res.MAX_USER_COUNT || 10);
              localStorage.setItem('plan', decodedToken.plan || res.subscription?.plan || '');
              
              // Force a browser tick to ensure localStorage is written
              setTimeout(() => {
                resolve(true);
              }, 100);
            });
          };
          
          // Update status before setting localStorage
          setStatus('Account ready! Finalizing setup...');
          
          // Wait for localStorage to be set
          await setLocalStorageItems();
          
          // Double check localStorage is set
          const token = localStorage.getItem('token');
          console.log("Token verification:", token ? "Token is set" : "Token is NOT set");
          
          if (!token) {
            throw new Error("Failed to store token in localStorage");
          }
          
          // Force a state update to ensure React knows we're ready to navigate
          setStatus('Account ready! Redirecting to dashboard...');
          
          // Use a state variable to track when we should navigate
          window.sessionStorage.setItem('onboarded', 'true');
          
          // Force navigation with a reload approach
          console.log("All set! Navigating to dashboard...");
          window.location.href = '/';
          // navigate('/');
        } else {
          // Handle error
          console.error("Onboarding Error:", response.error);
          setStatus('Error during setup. Please try again.');
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } catch (error) {
        console.error('Error in finalization:', error);
        setStatus('Something went wrong. Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };
    
    completeOnboarding();
  }, [leadId, navigate]);
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        padding: 4,
      }}
    >
      <CircularProgress size={60} sx={{ mb: 3 }} />
      <Typography variant="h6" align="center">
        {status}
      </Typography>
    </Box>
  );
};

export default LoadingRedirect;